<template>
  <nav class="lg:px-3">
    <div class="-mb-px flex justify-center lg:justify-start lg:space-x-8 flex-col md:flex md:flex-row" :aria-label="$t(ariaLabel)">
      <router-link v-for="tab in tabs" :key="tab.label" :to="tab.to"
                   exact-active-class="bg-white text-bpblue hover:bg-white group rounded-md px-3 py-2 flex items-center text-sm font-medium shadow-sm"
                   class="border-transparent text-gray-500 hover:text-gray-700 group inline-flex items-center py-4 px-1 border-b-2 font-medium text-xs lg:text-sm">
        <svg v-if="tab.icon" class="-ml-0.5 mr-2 h-5 w-5" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"
             :viewBox="tab.icon.solid ? '0 0 20 20' : '0 0 24 24'"
             :fill="tab.icon.solid ? 'currentColor' : 'none'"
             :stroke="tab.icon.solid ? null : 'currentColor'">
          <path v-for="path in tab.icon.paths" :key="path" :d="path"
                :fill-rule="tab.icon.solid ? 'evenodd' : null" :clip-rule="tab.icon.solid ? 'evenodd' : null"
                :stroke-linecap="tab.icon.solid ? null : 'round'" :stroke-linejoin="tab.icon.solid ? null : 'round'"
                :stroke-width="tab.icon.solid ? null : 2"/>
        </svg>
        <span>{{ $t(tab.label) }}</span>
      </router-link>
    </div>
  </nav>
</template>

<script>
/*
 * Pestañas de navegación entre rutas hijas (Productos, Proyectos…).
 * Cada pestaña: { to, label (clave i18n), icon: { paths: [d…], solid } }.
 * Los iconos de contorno son de 24×24 y los sólidos de 20×20 (Heroicons).
 */
export default {
  name: "RouteTabsComponent",
  props: {
    tabs: {
      type: Array,
      required: true
    },
    ariaLabel: {
      type: String,
      default: 'general.tabs'
    }
  }
}
</script>
